import React from "react";
import TeamImport from "../components/TeamImport";
import CommonTeamImportContainer from "../../common/containers/TeamImportContainer";

const TeamImportContainer = ({ onCancel = () => {}, onSave = () => {} }) => {
	return (
		<CommonTeamImportContainer
			onCancel={onCancel}
			onSave={onSave}
			TeamImport={TeamImport}
		/>
	);
};

export default TeamImportContainer;
